module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_24-5031283c91ff604bd0c595a57c5feff0.jpg";